import { render } from "./SalesByCategoryReport.vue?vue&type=template&id=38605c7d&scoped=true"
import script from "./SalesByCategoryReport.vue?vue&type=script&lang=js"
export * from "./SalesByCategoryReport.vue?vue&type=script&lang=js"

import "../inventory/inventoryReport.css?vue&type=style&index=0&id=38605c7d&scoped=true&lang=css&external"
import "./SalesByCategoryReport.vue?vue&type=style&index=1&id=38605c7d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38605c7d"]])

export default __exports__